import React, { Component } from "react";
import { Grid, Row, Col, Image, Button } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import createReactClass from "create-react-class";
import Carousel from "nuka-carousel";
import hyperlinks from "../../../src/util/hyperlinks";
import nameMapping from "../../../src/util/nameMapping";



export default class CorporateMembership extends Component {
    render() {
        let meetOurPartners;
        if (this.props.showCorporateMembers) {
            meetOurPartners = <Button className="meet-our-partners" href={hyperlinks["corporateMembers"]}>{"Meet our corporate members ❯"}</Button>;
        } else {
            meetOurPartners = <div className="meet-our-partners"></div>;
        }

        const carouselDecorators = [
            {
                component: createReactClass({
                    render() {
                        return <button style={{border: "none", background: "none", fontSize: "24px"}} onClick={this.props.previousSlide}>❮</button>;
                    }
                }),
                position: "CenterLeft",
                style: {
                    padding: 20,
                    top: "40%",
                    left: -60
                }
            },
            {
                component: createReactClass({
                    render() {
                        return <button style={{border: "none", background: "none", fontSize: "24px"}} onClick={this.props.nextSlide}>❯</button>;
                    }
                }),
                position: "CenterRight",
                style: {
                    padding: 20,
                    top: "40%",
                    right: -60
                }
            }
        ];

        const advisoryBoardCarouselItems = JSON.parse(this.props.currentMembers).map((boardMember, i) => {
            return (
                <div key={`carouselItem${i + 1}`}>
                    <a href={hyperlinks["corporateMembers"]}>
                        <div className="image-holder">
                            <Image src={boardMember.fingerprinted_logo} responsive />
                        </div>
                        <span>
                            <p>{nameMapping[boardMember.short_name] || boardMember.short_name}</p>
                        </span>
                    </a>
                </div>
            );
        });

        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background corporate-membership">
                    <Banner heading="Corporate Membership" />
                    <BackButton href={hyperlinks["home"]} text="❮ Home" />
                    <Image src="/assets/Corporate_membership_2023_1-f24efbc4d9259c89a141e5808bad9a7d32eb681f4259901bea8774c2469c9483.jpg" />
                    {meetOurPartners}
                    <Row>
                        <Col md={4}>
                            <div className="become-a-partner">
                                <div className="logo" style={{ padding: "10px", background: "white" }}>
                                  <img className="img-responsive ffs" src="/assets/jacobs-93696fab7fa2f67e5b028b2986c346178a75c205c57e3597c55547e956543d1b.jpg" />
                                </div>
                                <h2 style={{ fontSize: "20px", fontWeight: "600" }}>Foundation Partner</h2>
                                <Button href={`${hyperlinks["foundationPartner"]}?corporate=true`}>Learn More</Button>
                            </div>
                            <br />
                            <div className="advisory-board">
                                <a href={hyperlinks["corporateMembers"]}>
                                    <h2>Corporate Members</h2>
                                </a>
                                <Carousel
                                    slidesToShow={1}
                                    speed={600}
                                    cellSpacing={15}
                                    autoplay={false}
                                    autoplayInterval={4000}
                                    wrapAround={true}
                                    decorators={carouselDecorators}
                                >
                                    {advisoryBoardCarouselItems}
                                </Carousel>
                            </div>
                            <br />
                            <div className="become-a-partner">
                                <h2>Becoming A Corporate Member</h2>
                                <p>
                                    Help us celebrate <span className="light-blue-text">outstanding achievement</span> in the global water sector and <span className="light-blue-text">drive performance</span> across the sector.
                                </p>
                                <Button href={`${hyperlinks["newMember"]}?corporate=true`}>Learn More</Button>
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="corporate-membership-content">
                                <h2>The LUOW Advisory Board is fully aware that private sector involvement is vital to achieving the network's goals and mutual success of all water sector stakeholders.</h2>

                                <p>
                                    This is why a special category for Corporate Membership exists within the network. This is a new kind of partnership, enabling private companies to bring their expertise and ideas to the global conversation on utility innovation and drive aspirations in the water sector.
                                </p>

                                <p>
                                    <span className="blue-text"><strong>Be part of a movement working towards a better water industry.</strong></span> When a utility is accepted into the network as a gold standard service provider, this can drive a virtuous circle of further improvement and investment, and fuel the utilityís appetite for new projects, partnerships, and technologies.
                                </p>

                                <p>
                                    <span className="blue-text"><strong>Help support a global initiative focused on fuelling the aspirations of your utility partners and encouraging higher performance in their operations.</strong></span> Your support will help make better utility customers, bring new networking opportunities and will mean your organisation can be involved the leading discussions on utility objectives and innovation.
                                </p>

                                <h2>Why become a Corporate Member?</h2>

                                <ul>
                                    <li>
                                        <span className="blue-text"><strong>Demonstrate Corporate Social Responsibility</strong></span>
                                    </li>

                                    <li>
                                        <span className="blue-text"><strong>Network with the Advisory Board of the Leading Utilities of the World</strong></span>
                                    </li>

                                    <li>
                                        <span className="blue-text"><strong>Establish your Company's area of expertise</strong></span>
                                    </li>

                                    <li>
                                        <span className="blue-text"><strong>Contribute thought leadership to the development of the Network</strong></span>
                                    </li>

                                    <li>
                                        <span className="blue-text"><strong>Be part of the nomination process</strong></span>
                                    </li>
                                </ul>

                                <p>
                                    Corporate Membership in LUOW means a company has been acknowledged by the Advisory Board.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/CorporateMembership.jsx.erb